import { render, staticRenderFns } from "./ManagePaymentAccount.vue?vue&type=template&id=6b7584ba&"
import script from "./ManagePaymentAccount.vue?vue&type=script&lang=js&"
export * from "./ManagePaymentAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports